import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { InterpreterUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";
import { ShowDateTime } from "../../../common/controls";

export type InterpreterUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  nameError?: string;
  createdAt_: Date | null;
  lastUpdatedAt_: Date | null;
  interpreterUpdateStore: InterpreterUpdateStore;
};

export const InterpreterUpdateForm: React.FC<InterpreterUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      createdAt_ = null,
      lastUpdatedAt_ = null,
      interpreterUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="Interpreter"
              mode="update"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={interpreterUpdateStore.getCardErrors("null")}
              title={langStore.groupInterpreterLabel}
              collapsible={true}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(interpreterUpdateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    interpreterUpdateStore.warnings["name"]?.message
                  }
                  label={langStore.InterpreterNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.InterpreterNameDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="systemDates"
              errorText={interpreterUpdateStore.getCardErrors("systemDates")}
              title={langStore.groupInterpreterSystemDatesLabel}
              collapsible={true}
              expanded={interpreterUpdateStore.getCardState("systemDates")}
              toggleExpand={() =>
                interpreterUpdateStore.toggleCardState("systemDates")
              }
            >
              <FormControl fullWidth>
                <ShowDateTime
                  label={langStore.InterpreterCreatedAt_Label}
                  description={langStore.InterpreterCreatedAt_Description}
                  value={createdAt_}
                />
                <ShowDateTime
                  label={langStore.InterpreterLastUpdatedAt_Label}
                  description={langStore.InterpreterLastUpdatedAt_Description}
                  value={lastUpdatedAt_}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
